export const LIMITATIONS_FEATURES = {
  SIMULTANEOUS_COURSES: 'simultaneousCourses',
  MAX_PARTICIPANTS_IN_COURSE: 'maxParticipantsInCourse',
  MONTHLY_HOURS: 'monthlyHours',
};
